import { gql } from '@apollo/client'

import { FRAGMENT as JOB_CARD_FRAGMENT } from 'src/components/JobCard'

export default gql`
  query Jobs {
    jobs(perPage: 100) {
      nodes {
        ...JobCardComponent
      }
    }
  }

  ${JOB_CARD_FRAGMENT}
`
